const Toast = ({message, showToast, isSuccess}: { message: string; showToast: boolean; isSuccess: boolean }) => {
    return (
        <div>
            {showToast && isSuccess ? (
                    <div id="toast-success"
                         className="flex items-center w-full absolute top-24 right-2 max-w-xs p-4 mb-4 text-gray-500 bg-white rounded-lg shadow   dark:bg-gray-700 dark:text-gray-200"
                         role="alert">
                        <div
                            className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-green-500 bg-green-100 rounded-lg dark:bg-gray-700 dark:text-green-300">
                            <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                 fill="currentColor" viewBox="0 0 20 20">
                                <path
                                    d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                            </svg>
                            <span className="sr-only">Check icon</span>
                        </div>
                        <div className="ml-3 text-sm font-normal">{message} bir sonraki adıma geçebilirsiniz.</div>
                    </div>
                )
                : showToast && !isSuccess ? (
                    <div id="toast-danger"
                         className="flex items-center w-full absolute top-24 right-2 max-w-xs p-4 mb-4 text-gray-500 bg-white rounded-lg shadow dark:bg-gray-700 dark:text-gray-200"
                         role="alert">
                        <div
                            className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-red-500 bg-red-100 rounded-lg dark:text-red-300 dark:bg-red-600">
                            <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                 fill="currentColor"
                                 viewBox="0 0 20 20">
                                <path
                                    d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z"/>
                            </svg>
                            <span className="sr-only">Error icon</span>
                        </div>
                        <div className="ml-3 text-sm font-normal">{message}</div>
                    </div>
                ) : ''}
        </div>
    );
}
export default Toast
